export const ROUTE_PATHS = {
  LANDING_PAGE: '/',
  DATA_CATALOG: '/data-catalog',
  MASTER: '/master',
  LOGIN: '/login',
  SSO_LOGIN: '/sso-login',
  REGISTER: '/register',
  FORGET_PASSWORD: '/forget-password',

  REQUEST_NEW_DATASET: '/request-new-dataset',
  REQUEST_AVAILABLE_DATASET: '/request-available-dataset',
  ADD_OWN_DATASET: '/add-own-dataset',
  DATASET: '/dataset/:id',
  CONTACT_SALES_TEAM: '/contact-sales-team',
  PARTNERS: '/partners',
  BECOME_A_PARTNER: '/become-a-partner',
  AGENCY_CATALOG: '/agency-catalog',
  AGENCY_DETAIL: '/agency/:id',
  EDIT_AGENCY: '/agency/edit/:id',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  DATA_HUB: '/data-hub',
  DATA_HUB_DATASET: '/data-hub/dataset/:id',
  OWN_DATASET: '/own-dataset/:id',
  ENHANCE_DATASET: '/data-hub/enhance-data-set',
  VIEW_GUIDELINES: '/view-guidelines',
  VIEW_QA_INSTRUCTIONS: '/view-qa-instruction',
  PREVIEW_FILE: '/preview-file',

  PRIVACY_POLICY: '/privacy-policy',
  COOKIE_POLICY: '/cookie-policy',
  TERMS_OF_USE: '/terms-of-use',
  USER_AGREEMENT: '/user-agreement',
  FAQ: '/faq',

  ADD_TO_DATA_HUB: '/add-to-data-hub/:id',

  INTERNAL_APP_PORTAL: '/internal-app/portal',
  INTERNAL_APP_DATASET_MANAGEMENT_DASHBOARD: '/internal-app/dataset-management/dashboard',
  INTERNAL_APP_DATASET_MANAGEMENT_BULK_UPLOAD: '/internal-app/dataset-management/bulk-upload',
  INTERNAL_APP_DATASET_MANAGEMENT_ADD_NEW_DATASET: '/internal-app/dataset-management/add-new-dataset',
  INTERNAL_APP_DATASET_MANAGEMENT_ADD_NEW_DATASET_AI: '/internal-app/dataset-management/add-new-dataset-ai',
  INTERNAL_APP_DATASET_MANAGEMENT_VIEW_AI_DRAFT: '/internal-app/dataset-management/add-new-dataset-ai/:id',
  INTERNAL_APP_DATASET_MANAGEMENT_AI_DRAFTS: '/internal-app/dataset-management/ai-drafts',
  INTERNAL_APP_DATASET_MANAGEMENT_EDIT_DRAFT_DATASET: '/internal-app/dataset-management/edit-draft-dataset/:id',
  INTERNAL_APP_DATASET_MANAGEMENT_EDIT_DATASET: '/internal-app/dataset-management/edit-dataset/:id',
  /** Edit a pending/rejected submission whose payload_format is dataset_upsert (:id = submission id) — same UpsertDataset wizard, sourced from the submission instead of a live dataset. */
  INTERNAL_APP_DATASET_MANAGEMENT_EDIT_SUBMISSION_UPSERT: '/internal-app/dataset-management/edit-submission-upsert/:id',
  /** Edit a pending/rejected submission whose payload_format is dataset_edit (:id = submission id) — same EditDataset form, sourced from the submission instead of a live dataset. */
  INTERNAL_APP_DATASET_MANAGEMENT_EDIT_SUBMISSION_EDIT_FORM: '/internal-app/dataset-management/edit-submission/:id',
  INTERNAL_APP_DATASET_MANAGEMENT_DATASET_DETAIL: '/internal-app/dataset-management/dataset-detail/:id',
  INTERNAL_APP_DATASET_MANAGEMENT_AGENCY_AND_PROVIDERS: '/internal-app/dataset-management/agency-and-providers',
  INTERNAL_APP_DATASET_MANAGEMENT_ADD_AGENCY_OR_PROVIDER: '/internal-app/dataset-management/agency-and-providers/add',
  INTERNAL_APP_DATASET_MANAGEMENT_EDIT_AGENCY_OR_PROVIDER:
    '/internal-app/dataset-management/agency-and-providers/edit/:id',
  INTERNAL_APP_DATASET_MANAGEMENT_MANAGE_META_DATA: '/internal-app/dataset-management/manage-meta-data',
  INTERNAL_APP_TELEMETRY: '/internal-app/telemetry',

  COLLECTION_DETAIL: '/collection/:id',
  COLLECTION_MANAGEMENT: '/collection/management/:id',
  COLLECTION_DATASET_DETAIL: '/collection/:collectionId/dataset/:id',
  COLLECTION_REQUEST_REVIEW: '/collections/requests/:id/review',

  API_TOKENS: '/api-tokens',
  API_TOKENS_USAGE_GUIDE: '/api-tokens/usage-guide',
  INTERNAL_APP_DATASET_MANAGEMENT_USER_MANAGEMENT: '/internal-app/dataset-management/user-management',
  INTERNAL_APP_DATASET_MANAGEMENT_COLLECTION_REQUESTS: '/internal-app/dataset-management/collection-requests',
  INTERNAL_APP_DATASET_MANAGEMENT_APPROVAL_QUEUE: '/internal-app/dataset-management/approval-queue',
  INTERNAL_APP_DATASET_MANAGEMENT_MY_SUBMISSIONS: '/internal-app/dataset-management/my-submissions',
  INTERNAL_APP_RBAC: '/internal-app/rbac',
};
